<template>
  <Main>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-card class="pa-5" shaped color="#F8F8FF">
            <strong>AAM - SETTING PERIOD</strong>
            <v-row>
              <v-col cols="12">
                <v-card class="pa-2">
                   <v-row dense>
                    <v-col cols="3" align-self="center">MODUL NAME</v-col>
                    <v-col cols="9">
                        <v-autocomplete
                        v-model="modulName"
                        :items="VSELECT_MODUL"
                        item-text="modulName"
                        item-value="modulName"
                        class="mx-1"
                        style="width: 99%;"
                        solo
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="3" align-self="center">BRANCH NAME</v-col>
                    <v-col cols="9">
                         <!-- <v-autocomplete
                          v-model="branch"
                          :items="branchList"
                          item-text="BRANCH_CODE"
                          label="Branch"
                           class="mx-1"
                          style="width: 99%;"
                          solo
                        ></v-autocomplete> -->
                         <v-text-field
                          v-model="branch" 
                          label="Branch"
                          color="red darken-1"
                          :append-outer-icon="'mdi-magnify'"
                          @click:append-outer="dialogBranch = true"
                          @click="dialogBranch = true"
                          @input="reversedMessageBranch"
                          readonly
                        ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="3" align-self="center">QUARTAL</v-col>
                    <v-col cols="9">
                        <v-autocomplete
                        v-model="quartalName"
                        :items="VSELECT_QUARTAL"
                        item-text="quartalName"
                        item-value="quartalName"
                        class="mx-1"
                        style="width: 99%;"
                        solo
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="3" align-self="center">START PERIOD</v-col>
                    <v-col cols="9">
                      <v-menu
                        v-model="openPeriodStart"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                          color="red darken-1"
                            v-model="periodStart"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            solo
                            hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="periodStart" @input="openPeriodStart = false" color="red darken-1"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                   <v-row dense>
                    <v-col cols="3" align-self="center">END PERIOD</v-col>
                    <v-col cols="9">
                      <v-menu
                        v-model="openPeriodEnd"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                          color="red darken-1"
                            v-model="periodEnd"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            solo
                            hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="periodEnd"  @input="openPeriodEnd = false" color="red darken-1"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  
                  
                              
                  <v-row dense>
                    <v-col cols="3"></v-col>
                    <v-col cols="9">
                      <v-btn @click="addPeriod" color="warning" block>ADD/UPDATE</v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
               <v-row >
                    <v-col cols="7">
                       
                    </v-col>
                    <v-col cols="5">
                      <v-autocomplete
                       @change="getData"
                        v-model="modulNameFilter"
                        :items="VSELECT_MODUL"                        
                        label="Modul Name"
                        item-text="modulName"
                        item-value="modulName"
                        class="mx-1"
                        style="width: 99%;"
                        solo
                      ></v-autocomplete>
                    </v-col>
                 </v-row>
            <v-row>
          
               
               <v-col md=12>
                 <v-data-table
                  :headers="dtHeaderDetail"
                  :items="dtItemDetail"
                  :search="search"
                  :loading="dtLoading"
                  loading-text="Fetching Data..."
                  class="elevation-1"
                ></v-data-table>
              </v-col>
              
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialogBranch"
          scrollable
          max-width="500px"
        >
        <template>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              v-model="branch"
              :headers="headersBranch"
              :items="arrBranch"
              :search="search"
              item-key="BRANCH_CODE"
              show-select
              class="elevation-1"
              disable-pagination
              hide-default-footer
            ></v-data-table>
          </v-card>
        </template>
        </v-dialog>
      </v-row>
    </template>

    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </Main>
</template>

<script>
import Main from "@/Main.vue";
import moment from "moment";

export default {
  components: {
    Main
  },
  data() {
    return {
      salesName: JSON.parse(localStorage.getItem('userData')).POSITION_CODE,
      dtLoading: false,
      search: "",
      isLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      periodStart: moment().format("YYYY-MM-DD"),
      periodEnd: moment().format("YYYY-MM-DD"),
      modulName: "",
      quartalName: "",
      branch: "",
      arrBranch : [],
      headersBranch: [
          { text: 'BRANCH CODE', value: 'BRANCH_CODE' }
        ],
       search: '',
        singleSelect: false,
      modulNameFilter: "",
      openPeriodStart: false,
      openPeriodEnd: false,
      dialogBranch: false,
      summary: [],
      detail: [],
      salesList:[],
      orgID: JSON.parse(localStorage.getItem('userData')).ORG_ID,
      dtItemSummary: [],
       branchList: [],
      dtHeaderDetail: [
       // { text: "ID", value: "ID" },
        { text: "TYPE", value: "TYPE" },
        { text: "BRANCH NAME", value: "BRANCH_CODE" },
        { text: "START DATE", value: "START_DATE" },
        { text: "END DATE", value: "END_DATE" },
         { text: "QUARTAL", value: "QUARTAL" },
       // { text: "STATUS", value: "IS_ACTIVE" }
      ],
      dtItemDetail: [],
      VSELECT_MODUL: [
        { modulName: "TARGET",},
        { modulName: "INCENTIVE",},
        { modulName: "FIXED CALL PLAN",},
        { modulName: "MASTER CALL PLAN",},
        { modulName: "NEW MAPPING SALES ASSIGNMENT",},
        { modulName: "MAPPING SALESREP",},
      ],
      VSELECT_QUARTAL: [
        { quartalName: "1",},
        { quartalName: "2",},
        { quartalName: "3",},
        { quartalName: "4",}
      ],
    };
  },
  computed: {
    reversedMessageBranch: function () {
       if(this.branch.length>0){
        let items = this.branch;
        let arrItem=[];
        items.map(function(item) {
          arrItem.push(item.BRANCH_CODE);
        });
        this.branch = arrItem.toString();
        return arrItem.toString();
      }
    }
  },
  mounted() {	
		this.getData();
    const orgID = JSON.parse(localStorage.getItem("userData")).ORG_ID;
    this.loadBranchList(orgID);
	},
  methods: {
    getData() {
      this.isLoading = true;
      const body = {
        typeModul: this.modulNameFilter
      };
      this.$http
        .post('/adjust-incentive/setupPeriodeInput', body, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then(res => {
          this.isLoading = false;
          let arrayList = res.data.data;
          console.log('arrayList rizki ', arrayList)
           arrayList.forEach((obj, index) => {
            arrayList[index].START_DATE = moment(
              arrayList[index].START_DATE
            ).format("DD MMM YYYY");
            arrayList[index].END_DATE = moment(
              arrayList[index].END_DATE
            ).format("DD MMM YYYY");
          });

          this.dtItemDetail = arrayList;
        })
        .catch(err => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    loadBranchList(orgID) {
      this.isLoading = true;
      this.$http
        .post("/call-management/prepareFilter", { orgID: orgID }, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          this.isLoading = false;
          let { data } = res.data;
          // this.branchList = data.BRANCH_LIST;
          let branchListArr = data.BRANCH_LIST;
          let testData = []
          branchListArr.forEach((val, index) => {
            if (branchListArr[index].BRANCH_CODE !=="ALL BRANCH"){
               testData.push({"BRANCH_CODE":branchListArr[index].BRANCH_CODE})
            }
          });
          console.log('testData ', testData)
         // this.branchList = testData;
          this.arrBranch = testData;
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err.toString());
        });
    },
    addPeriod() {
      if( this.modulName!==""){
          let data = {
            modulName: this.modulName,
            periodStart: this.periodStart,
            periodEnd: this.periodEnd,
            quartalName: this.quartalName,
            branch: this.branch
          };
          this.isLoading = true;          
          this.$http
          	.post('/adjust-incentive/addPeriod', data, {
              headers: {
                "api-key": this.$apiKey
              }
            })
          	.then((res) => {
          		this.isLoading = false;
          		this.getData();
              this.modulName="";
             // this.periodStart="";
             // this.periodEnd="";
              this.quartalName="";
              this.branch="";
          	})
          	.catch((err) => {
          		this.isLoading = false;
          		this.showSnackbar(err.toString());
          	});
      }else{
        this.showSnackbar("Silahkan isi nama modul terlebih dahulu.");
      }
      
		},
    onCustomerSelected(event,index){
      this.salesList.push({POSITION_CODE:""});
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    }
  }
};
</script>
